import { SVGInterface } from "../../interface";

const List = ({ color, ...rest }: SVGInterface) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M8 5.5H21V7.5H8V5.5ZM3 5H6V8H3V5ZM3 11H6V14H3V11ZM3 17H6V20H3V17ZM8 11.5H21V13.5H8V11.5ZM8 17.5H21V19.5H8V17.5Z"
      fill={color || "#0E171F"}
    />
  </svg>
);

export default List;
